/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

class CommonLink extends React.Component {
	render() {
		return (
			<div
				role="presentation"
				className="d-inline-block mx-3"
				onClick={this.props.onClick}
				onFocus={() => {}}
			>
				<a
					href="#"
					className="text-link-muted d-inline-flex align-items-center"
				>
					<i
						className={`ddc-icon ${this.props.iconClass} ${
							this.props.galleryIconColor
						} mr-3 align-middle`}
					/>
					<span>{this.props.linkName}</span>
				</a>
			</div>
		);
	}
}
CommonLink.propTypes = {
	onClick: PropTypes.func.isRequired,
	iconClass: PropTypes.string.isRequired,
	galleryIconColor: PropTypes.string.isRequired,
	linkName: PropTypes.string.isRequired
};
export default CommonLink;



// WEBPACK FOOTER //
// ./src/components/photoswipe/CommonLink.jsx